import { Button } from "@shared-kernel/primary/shared/shadcn/ui/button";
import { FileText } from "lucide-react";

interface Props {
  label: string;
  url: string;
}

export const DocumentButton = ({ label, url }: Props) => (
  <Button variant="outline" className="w-full justify-start gap-2" asChild>
    <a href={url} target="_blank" rel="noopener noreferrer">
      <FileText className="size-4" />
      {label}
    </a>
  </Button>
);
